<template>
  <form class="step" @submit.prevent>
    <bim-text type=medium bold class="mb-6">{{ $bimTranslate('signUp.additionalInfo', activeLang) }}</bim-text>

    <bim-input
      autocomplete="off"
      class="step__item step__item--padding"
      v-model="form.phone"
      mask=phone
      :placeholder="$bimTranslate('signUp.mobilePhone', activeLang)"
      :formModel="_self"
      formKey="form.phone"
    />

    <!-- Для производителя -->
    <bim-input
      autocomplete="off"
      v-if="form.context.role === 'manufacturer'"
      class="step__item step__item--padding"
      v-model="form.context.companyName"
      :placeholder="$bimTranslate('signUp.company', activeLang)"
      :formModel="_self"
      formKey="form.context.companyName"
    />
    <!-- Для проектировщика -->
    <bim-select
      v-else
      class="step__item"
      width="100%"
      v-model="form.context.specialisation"
      :placeholder="$bimTranslate('signUp.specialisationNotSelected', activeLang)"
      :options="options"
    />

    <div class="step__button-group button-group mt-9">
      <bim-button
        class="button-group__button"
        @click.prevent="$emit('skip') && sendForm()"
        :label="$bimTranslate('signUp.buttons.skip', activeLang)"
        color=gray
      />

      <bim-button
        class="button-group__button"
        @click.prevent="$emit('finish') && sendForm()"
        :label="$bimTranslate('signUp.buttons.finish', activeLang)"
      />
    </div>
  </form>
</template>

<script>
import bimText from '@/components/text/bimText/bimText'
import bimInput from '@/components/form/bimInput/bimInput'
import bimButton from '@/components/form/bimButton/bimButton'
import bimSelect from '@/components/form/bimSelect/bimSelect'

import StepMixin from './step.mixin'

export default {
  components: {
    bimText,
    bimInput,
    bimButton,
    bimSelect
  },
  props: {
    companyRequired: Boolean
  },
  mixins: [StepMixin],
  computed: {
    options () {
      return this.$bimTranslate('signUp.specialisations', this.activeLang).map(spec => ({
        label: spec,
        value: spec
      }))
    },
    formValidation () {
      const fields = {}

      const phone = this.form.phone
      if (phone && (phone.match(/\d/g) || []).length > 1) {
        fields['form.phone'] = ['phone']
      }

      if (this.companyRequired) {
        fields['form.context.companyName'] = ['required']
      }

      return fields
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  .step__item--padding {
    padding-bottom: 16px;
  }
}

.button-group {
  display: flex;

  @media screen and (max-width: 576px) {
    flex-direction: column;
  }

  .button-group__button {
    flex-grow: 1;
  }

  .button-group__button:nth-child(1) {
    margin-right: 19px;

    @media screen and (max-width: 576px) {
      margin-right: 0;
      margin-bottom: 19px;
    }
  }
}
</style>
